import * as React from "react";
import Button from "@mui/material/Button";
import Dialog from "@mui/material/Dialog";
import Divider from "@mui/material/Divider";
import AppBar from "@mui/material/AppBar";
import Toolbar from "@mui/material/Toolbar";
import IconButton from "@mui/material/IconButton";
import Typography from "@mui/material/Typography";
import CloseIcon from "@mui/icons-material/Close";
import Slide from "@mui/material/Slide";
import { TransitionProps } from "@mui/material/transitions";
import EntrezTableWithPaginationTopBottom from "./EntrezTableWithPaginationTopBottom";
import { convertFirstCharToCaps } from "../../app/util/util";
import { useAppSelector } from "../../app/store/configureStore";
import { Box, LinearProgress } from "@mui/material";
import { entrezDbSelectors } from "../../app/store/entrezDbSlice";

const Transition = React.forwardRef(function Transition(
  props: TransitionProps & {
    children: React.ReactElement;
  },
  ref: React.Ref<unknown>
) {
  return <Slide direction="up" ref={ref} {...props} />;
});

// interface Props {
//   // formattedQuery: string;
//   metaData: PaginationData;
//   columns: any[];
//   selectedColumns: string[];
//   dbRecords: DBRecords;
//   selectedDB: string;

//   onPageChange: (page: number) => void;
//   onPageSizeChange: (pageSize: number) => void;
//   onApplySelectedColumns: (selectedCols: string[]) => void;
// }

export default function FullScreenTableView() {
  const { dbParams,status } = useAppSelector((state) => state.entrezDb);
  
  const selectedDbWithItsState = useAppSelector((state) =>
  entrezDbSelectors.selectById(state, dbParams.db)
);
  const [open, setOpen] = React.useState(false);

  const handleClickOpen = () => {
    setOpen(true);
  };

  const handleClose = () => {
    setOpen(false);
  };

  return (
    <div>
      <Button sx={{ml: 0,
                  /*height: "52px"*/ }} variant="contained" onClick={handleClickOpen}
      disabled={!selectedDbWithItsState?.dbRecords ||
         selectedDbWithItsState.dbRecords.dbRows.length === 0}>
        View Full Screen
      </Button>
      <Dialog
        fullScreen
        open={open}
        onClose={handleClose}
        TransitionComponent={Transition}
      >
        <AppBar sx={{ position: "relative" }}>
          <Toolbar variant="dense">
            <IconButton
              edge="start"
              color="inherit"
              onClick={handleClose}
              aria-label="close"
            >
              <CloseIcon />
            </IconButton>
            <Typography sx={{ ml: 2, flex: 1 }} variant="h6" component="div">
              {convertFirstCharToCaps(dbParams.db)}
            </Typography>

            <Button autoFocus color="inherit" onClick={handleClose}>
              Close
            </Button>
          </Toolbar>
          {status.includes("pendingEFetchESummaryOrEFetchAsync") && (
            <Box sx={{ width: "100%" }}>
              <LinearProgress color="secondary" />
            </Box>
          )}
        </AppBar>
        <Divider sx={{ mt: 1, mb: 1 }}></Divider>
        <EntrezTableWithPaginationTopBottom></EntrezTableWithPaginationTopBottom>
      </Dialog>
    </div>
  );
}
